import React from 'react';
import { NavLink } from 'react-router-dom';

const ADMIN_SECTIONS = [
    { path: '/admin', label: 'Аниме', end: true },
    { path: '/admin/kodik', label: 'Kodik' },
    { path: '/admin/manga', label: 'Манга' },
    { path: '/admin/users', label: 'Пользователи' },
    { path: '/admin/reviews', label: 'Отзывы' },
    { path: '/admin/moderation', label: 'Модерация' },
    { path: '/admin/category', label: 'Категории' },
];

const AdminNavigation = () => (
    <nav className="ui-chips admin-navigation" aria-label="Разделы админ-панели">
        {ADMIN_SECTIONS.map((section) => (
            <NavLink
                key={section.path}
                to={section.path}
                end={section.end}
                className={({ isActive }) => `ui-chip${isActive ? ' is-active' : ''}`}
            >
                {section.label}
            </NavLink>
        ))}
    </nav>
);

export default AdminNavigation;
